export const environment = {
  env: "QA",
  production: true,
  serviceWorkerEnabled: true,
  baseUrl: "https://chat-qa.roarinc.com",
  apiUrl: 'https://api-qa.roarinc.com/comms'
};
